import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Input } from '/imports/ui/Input';
import { css } from '/imports/ui/css';
import { strings } from '/imports/strings';
import { Account, listAccountsForOrg, accountDisplayName } from '/imports/api/accounts';

const PickerStyled = styled.div`
  position: relative;
  .selected {
    display: flex; align-items: center; gap: 0.5rem;
    border: ${css.inputBorder}; border-radius: ${css.inputBorderRadius}; padding: 0.45rem 0.75rem;
    min-height: ${css.inputHeight}; box-sizing: border-box;  /* match the other form inputs (3rem) */
  }
  .selected .clear { margin-left: auto; background: none; border: none; cursor: pointer; color: ${css.grey4}; font-size: 0.9rem; }
  .menu {
    position: absolute; z-index: 5; left: 0; right: 0; margin-top: 0.2rem;
    background: ${css.white}; border: ${css.inputBorder}; border-radius: ${css.inputBorderRadius};
    max-height: 14rem; overflow: auto; box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
  .opt { padding: 0.4rem 0.75rem; cursor: pointer; }
  .opt:hover { background: ${css.grey8}; }
`;

interface Props {
  value?: string;
  onChange: (accountId?: string, account?: Account) => void;
}

/** Inline search-and-select picker for an org account (used to link a stakeholder to a platform user). */
export const AccountPicker = ({ value, onChange }: Props) => {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  useEffect(() => { listAccountsForOrg.call().then(setAccounts).catch(() => undefined); }, []);

  const selected = accounts.find((a) => a._id === value);
  if (value && selected) {
    return (
      <PickerStyled>
        <div className="selected">
          <span>{accountDisplayName(selected)}{selected.email ? ` · ${selected.email}` : ''}</span>
          <button className="clear" onClick={() => onChange(undefined)}>✕</button>
        </div>
      </PickerStyled>
    );
  }

  const q = search.trim().toLowerCase();
  const matches = q ? accounts.filter((a) => `${accountDisplayName(a)} ${a.email || ''}`.toLowerCase().includes(q)).slice(0, 8) : [];
  return (
    <PickerStyled>
      <Input value={search} onChange={(v) => { setSearch(v || ''); setOpen(true); }} placeholder={strings.Search()} />
      {
        open && matches.length > 0 &&
          <div className="menu">
            {
              matches.map((a) => (
                <div key={a._id} className="opt" onClick={() => { onChange(a._id, a); setSearch(''); setOpen(false); }}>
                  {accountDisplayName(a)}{a.email ? ` · ${a.email}` : ''}
                </div>
              ))
            }
          </div>
      }
    </PickerStyled>
  );
};
